<template>
  <img :src="logoPath" :alt="organisation.name" :style="imageStyle" />
</template>
<script>
import { defineComponent, computed } from "vue";
import gql from "fraql";

export default defineComponent({
  name: "AppShowTopOrganisationLogo",
  props: {
    organisation: {
      type: Object,
      required: true
    },
    imageStyle: {
      type: String,
      default: "width: 32px;height: 32px;"
    }
  },
  setup(props) {
    const logoPath = computed(() => {
      return process.env.VUE_APP_API_URL + props.organisation.logoPath;
    });

    return {
      logoPath
    };
  },
  fragments: {
    organisationFields: gql`
      fragment _ on Organisation {
        id
        name
        logoPath
      }
    `
  }
});
</script>
